import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { BrandingService } from '@core/services/branding.service';
import { PmaService } from '@app/pma/pma.service';
import { filter, map, take } from 'rxjs/operators';

export const amtrustRedirectGuard: CanActivateFn = (route, state) => {
  const brandingService = inject(BrandingService);
  const pmaService = inject(PmaService);

  return brandingService.brandingInfo$.pipe(
    filter(info => Object.keys(info).length > 0),
    take(1),
    map(() => {
      if (!brandingService.getIsAmtrustClientSnapshot()) {
        return true;
      }

      const amtrustClientUrl = brandingService.getAmtrustClientUrlSnapshot();

      const excludedUrls = ['PrivacyPolicy', 'FraudNotice'];

      if (excludedUrls.some(url => state.url.endsWith(url))) {
        return true;
      }

      if (!amtrustClientUrl) {
        return true;
      }

      const prepopulate = route.queryParams['prepopulate'];
      pmaService.redirectToAmtrustApp({
        parentUrl: window.location.origin,
        amtrustClientUrl,
        ...(prepopulate ? { prepopulate } : {}),
      });
      return false;
    }),
  );
};
